/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetToolMetadataRequestBody = {
  /**
   * Hint that the tool may perform destructive updates to its environment
   */
  destructiveHint?: boolean | undefined;
  /**
   * Hint that calling the tool repeatedly with the same arguments has no additional effect
   */
  idempotentHint?: boolean | undefined;
  /**
   * The ID of the MCP server the tool metadata belongs to
   */
  mcpServerId: string;
  /**
   * Hint that the tool may interact with an open world of external entities
   */
  openWorldHint?: boolean | undefined;
  /**
   * Hint that the tool does not modify its environment
   */
  readOnlyHint?: boolean | undefined;
  /**
   * A human-readable title for the tool
   */
  title?: string | undefined;
  /**
   * The name of the tool to update
   */
  toolName: string;
};

/** @internal */
export type SetToolMetadataRequestBody$Outbound = {
  destructive_hint?: boolean | undefined;
  idempotent_hint?: boolean | undefined;
  mcp_server_id: string;
  open_world_hint?: boolean | undefined;
  read_only_hint?: boolean | undefined;
  title?: string | undefined;
  tool_name: string;
};

/** @internal */
export const SetToolMetadataRequestBody$outboundSchema: z.ZodMiniType<
  SetToolMetadataRequestBody$Outbound,
  SetToolMetadataRequestBody
> = z.pipe(
  z.object({
    destructiveHint: z.optional(z.boolean()),
    idempotentHint: z.optional(z.boolean()),
    mcpServerId: z.string(),
    openWorldHint: z.optional(z.boolean()),
    readOnlyHint: z.optional(z.boolean()),
    title: z.optional(z.string()),
    toolName: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      destructiveHint: "destructive_hint",
      idempotentHint: "idempotent_hint",
      mcpServerId: "mcp_server_id",
      openWorldHint: "open_world_hint",
      readOnlyHint: "read_only_hint",
      toolName: "tool_name",
    });
  }),
);

export function setToolMetadataRequestBodyToJSON(
  setToolMetadataRequestBody: SetToolMetadataRequestBody,
): string {
  return JSON.stringify(
    SetToolMetadataRequestBody$outboundSchema.parse(setToolMetadataRequestBody),
  );
}
